import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-role-assignment',
  templateUrl: './edit-role-assignment.page.html',
  styleUrls: ['./edit-role-assignment.page.scss'],
})
export class EditRoleAssignmentPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
